<script>
import axios from "axios";
import store from "../store/";
import ELEMENT from "element-ui";
import router from "../router/";
let { Notification, Loading, Message } = ELEMENT;
const service = axios.create({
  baseURL: "/", //
  timeout: 60000
});

//全局请求拦截
service.interceptors.request.use(
  response => {
    return response;
  },
  error => {
    return Promise.resolve(error.response);
  }
);

//全局响应拦截
service.interceptors.response.use(
  response => {
    if (response && response.data && response.data.code == 11) {
      // Message.warning('当前用户权限发生变更，2秒后页面将会刷新跳转到首页')
      // let btnPermission = response.data.btnPermission
      // if(btnPermission){
      // 	localStorage.setItem('permission',JSON.stringify(btnPermission))
      // }
      // response.data.msg='success'
      // response.data.code = 0
      // setTimeout(()=>{
      // 	router.push({path: "/"})
      // 	window.location.reload()
      // },2000)
      // response.data.add='自定义添加数据'
      // return response
    }
    if (response && response.data && response.data.code == 10 && !response.request.responseURL.includes("bi/getWorkshopDashboard")) {
      if (!window.isLogOut) {
        Message.error("当前登录过期,请重新登录");
      }
      window.isLogOut = true;
      localStorage.setItem("token", "");
      response.data.msg = "success";
      response.data.code = 0;
      setTimeout(() => {
        router.push({ path: "/Login" });
      }, 0);
    }
    return response;
  },
  error => {
    return Promise.resolve(error.response);
  }
);

const loadingOption = {
  lock: true,
  text: "Waiting",
  spinner: "el-icon-loading",
  background: "rgba(0, 0, 0, 0.7)"
};
let loading = Object;

export default {
  component: {
    router
  },
  get(option = {}, resolve, reject) {
    if (option.type != null && option.type == "sync") {
      loading = Loading.service(loadingOption);
    }
    if (!option.url.includes("openapi")) {
      option.params.token = localStorage.getItem("token");
    }
    option.params.time = new Date().getTime();
    for (let p in option.params) {
      if (typeof option.params[p] == "string") {
        option.params[p] = option.params[p].trim();
      }
    }
    let config = {
      params: option.params
    };
    //dataType传入blob返回二进制数据
    if (option.dataType == "blob") {
      config.responseType = "blob";
      config.headers = {
        "Content-Type": "application/x-www-form-urlencoded"
      };
    }
    return service
      .get(option.url, config)
      .then(res => {
        if (option.type != null && option.type == "sync") {
          loading.close();
        }
        if (resolve) {
          resolve(res.data);
        }
        // if(res.data.code == 10){
        // 	Message({message: res.data.message, type: 'error'});
        // 	router.push({path: '/Login',name: 'Login'})
        // 	return
        // }
        option.success && option.success(res.data);
      })
      .catch(err => {
        if (option.type != null && option.type == "sync") {
          loading.close();
        }
        if (reject) {
          reject(err);
        }
        var msg = "网络请求错误";
        if (err.response != null) {
          if (err.response.status == 504) {
            msg = "网关连接超时，请重试";
          } else if (err.response.status == 500) {
            msg = "服务器存在错误";
          } else {
            msg = "错误，代码:" + err.response.status;
            console.log(err.response);
          }
        } else {
          msg = "刷新过快，请等待响应";
          return;
        }
        Notification({
          title: "错误",
          message: msg,
          duration: 0
        });
      });
  },
  post(option = {}, resolve, reject) {
    if (option.type != null && option.type == "sync") {
      loading = Loading.service(loadingOption);
    }

    option.params.token = localStorage.getItem("token");
    //dataType传入blob返回二进制数据
    let config = {};
    let form = new FormData();
    if (option.dataType == "formblob") {
      config.responseType = "blob";
    }
    if (option.dataType == "blob") {
      config.responseType = "blob";
      config.headers = {
        "Content-Type": "application/x-www-form-urlencoded"
      };
      let keys = Object.keys(option.params);
      keys.forEach(key => {
        form.append(key, option.params[key]);
      });
    }
    for (let p in option.params) {
      if (typeof option.params[p] == "string") {
        option.params[p] = option.params[p].trim();
      }
    }
    return service
      .post(option.url, option.dataType == "blob" ? form : option.params, config)
      .then(res => {
        if (resolve) {
          resolve(res.data);
        }
        if (option.type != null && option.type == "sync") {
          loading.close();
        }
        if (res.status == 408) {
          Notification({
            title: "错误",
            message: "请求超时",
            duration: 2000
          });
          return;
        }
        // if(res.data.code == 10){
        // 	Message({message: "登入过期！", type: 'error'});
        // 	router.push({path: '/Login',name: 'Login'})
        // 	return
        // }
        option.success && option.success(res.data);
      })
      .catch(err => {
        if (reject) {
          reject(err);
        }
        if (option.type != null && option.type == "sync") {
          loading.close();
        }
        // console.log(err);
        var msg = "网络请求错误";
        if (err.response != null) {
          if (err.response.status == 504) {
            msg = "网关连接超时，请重试";
          } else if (err.response.status == 500) {
            msg = "服务器存在错误";
          } else {
            msg = "错误，代码:" + err.response.status;
            console.log(err.response);
          }
        } else {
          msg = "刷新过快，请等待响应";
          return;
        }

        Notification({
          title: "错误",
          message: msg,
          duration: 2000
        });
      })
      .finally(() => {
        // if (option.type!=null&&option.type == "sync") {
        // 	loading.close();
        // }
      });
  },
  //返回Promise对象外部可直接使用async和await来调用
  getAsync(option = {}) {
    return new Promise((resolve, reject) => {
      this.get(option, resolve, reject);
    });
  },
  //返回Promise对象外部可直接使用async和await来调用
  postAsync(option = {}) {
    return new Promise((resolve, reject) => {
      this.post(option, resolve, reject);
    });
  },
  loading() {
    //返回出去方便外部调用
    return Loading.service(loadingOption);
  }
};
</script>



// WEBPACK FOOTER //
// src/util/RequestUtil.vue